import { ProgressIndicator, ProgressSpinner } from '@sainsburys-tech/luna-progress'

function LoadingIndicator (props){

    return (
        <>
            <div className="ln-u-text-align-center ln-u-soft">

                <ProgressIndicator page loading={props}>
                    <ProgressSpinner light />
                    Loading...
                </ProgressIndicator>
            </div>
        </>
    )
}

export default LoadingIndicator
